import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase.js';

// ─────────────────────────────────────────────────────────────────────────
// School ↔ marketplace subscription — client library. See
// functions/schoolMarketplace.js for the full model: a school owner
// subscribes their school to a marketplace listing (paid once from the
// school wallet, or free for a ₹0 listing); every student/teacher at that
// school then gets free access automatically, tagged "Subscribed by
// School" — see src/views/school.js (browse/subscribe) and src/views/home.js
// (the read-only section every non-owner member sees).
// ─────────────────────────────────────────────────────────────────────────

const subscribeSchoolToListingFn = httpsCallable(functions, 'subscribeSchoolToListing');
const unsubscribeSchoolFromListingFn = httpsCallable(functions, 'unsubscribeSchoolFromListing');
const listMySchoolSubscriptionsFn = httpsCallable(functions, 'listMySchoolSubscriptions');
const getSchoolSubscriptionContentFn = httpsCallable(functions, 'getSchoolSubscriptionContent');

// School-owner only. Every member (owner included) gets the same free
// read-only viewer — see functions/schoolMarketplace.js.
export async function subscribeSchoolToListing(listingId) {
  const { data } = await subscribeSchoolToListingFn({ listingId, idempotencyKey: crypto.randomUUID() });
  return data;
}

export async function unsubscribeSchoolFromListing(listingId) {
  await unsubscribeSchoolFromListingFn({ listingId, idempotencyKey: crypto.randomUUID() });
}

// Any member (owner, teacher, or student) of a school — throws
// failed-precondition if the caller isn't linked to a school at all.
export async function listMySchoolSubscriptions() {
  const { data } = await listMySchoolSubscriptionsFn({});
  return data; // { schoolCode, subscriptions: [{ listingId, title, emoji }] }
}

export async function getSchoolSubscriptionContent(listingId) {
  const { data } = await getSchoolSubscriptionContentFn({ listingId });
  return data; // { title, courseId, creatorUid, items: [{ topicId, title, html }] }
}
